module.exports = __webpack_public_path__ + "static/media/lingdaima.2ce9051.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/lingdaima.mp4
// module id = 9ecD
// module chunks = 0